import urlVars from '../../js/lib/urlVars';
import request from '../../js/lib/request';
import currentLang from '../../js/lib/currentLang';
import smoothScroll from '../../js/lib/smoothScrollTo';

const eventSort = document.querySelectorAll('.js-event-sort');
if (eventSort.length !== 0) {
	// Use different URL for Static/MVC
	for (var x = 0; x < eventSort.length; x++) {
		const id = eventSort[x].id;
		const region = eventSort[x].getAttribute('data-region');
		const eventType = eventSort[x].getAttribute('data-category');
		const url = `/EventListingPage/RefreshEvents/?regionCategory=${region}&eventType=${eventType}&lang=${currentLang()}`;

		// Vue Component
		request().get(url).then(function(response) {
			const events = new Vue({
				// events Element ~> this.$el
				el: '#' + id,
				// Define Schema ~> set to null/''
				data: {
					eventList: '',
					isLoading: true,
				},
				// When Component is Mounted, run Methods
				mounted: function() {
					const self = this;

					self.eventList = response;

					self.$refs['sort_selector'].addEventListener('change', (event)=>{
						self.changeItem(event);
					}, false);

					if(window.addEventListener)
					{
						window.addEventListener('popstate', function(event) {
							self.checkUrl();
						});
					}

					self.checkUrl();
					self.isLoading = false;
				},
				// Methods
				methods: {
					checkUrl: function() {
						const self = this;

						var qs = urlVars();
						if(qs['region'] && qs['region'] == region && qs['sortBy'].length > 0)
							self.getUrl(qs['sortBy']);
					},
					changeItem: function(event) {
						const self = this;
						
						// push state to browser address bar
						window.history.pushState({'html':response},'', '?region=' + region + '&sortBy=' + event.target.value);

						self.getUrl(event.target.value);
					},
					getUrl: function(sort) {
						const self = this;
						self.isLoading = true;

						var reqUrl = url;
						if(sort && sort.length > 0)
						{
							reqUrl += `&sortBy=${sort}`;
							self.$refs['sort_selector'].value = sort;
						}
						else
							self.$refs['sort_selector'].selectedIndex = 0;

						request().get(`${reqUrl}`).then(function(responseHTML) {
							self.eventList = responseHTML;
							self.isLoading = false;
						});
					},
				}
			});
			
		});
	}
}

// Event Nav
const eventNavigation = document.getElementById('eventNavigation');
if (eventNavigation) {
	const scroll = new smoothScroll('.event-nav__button', {
		offset: 20,
	});
	eventNavigation.addEventListener('change', (event) => {
		document.getElementById(event.target.value + '_Region').scrollIntoView();
	}, false);
}



// WEBPACK FOOTER //
// ../components/events/eventsSort.js